import React, { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeProvider';
import { api } from '../utils/api';
import logoWhite from '../assets/logo-repro-white.svg';
import logoDark from '../assets/logo-repro-v3-dark.svg';

export default function ForgotPassword() {
  const { resolvedTheme } = useTheme();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const logo = resolvedTheme === 'dark' ? logoWhite : logoDark;

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-100 px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={logo} alt="RePro" className="h-8 mx-auto mb-4" />
          <h1 className="text-xl font-semibold text-base-content">Forgot Password</h1>
          <p className="text-sm text-base-content/60 mt-1">
            Enter your email to receive a reset link
          </p>
        </div>

        <div className="card bg-base-200 shadow-md">
          <div className="card-body gap-4">
            {submitted ? (
              <div>
                <div className="alert alert-success text-sm">
                  If an account exists with that email, a password reset link has been sent. Check
                  your inbox.
                </div>
                <Link to="/login" className="btn btn-ghost btn-sm w-full mt-4">
                  Back to login
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                {error && <div className="alert alert-error text-sm mb-4">{error}</div>}

                <div className="form-control mb-4">
                  <label className="label" htmlFor="email">
                    <span className="label-text">Email</span>
                  </label>
                  <input
                    id="email"
                    type="email"
                    required
                    autoComplete="email"
                    autoFocus
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="input input-bordered w-full"
                    placeholder="admin@reprostream.com"
                  />
                </div>

                <button type="submit" disabled={loading} className="btn btn-primary w-full">
                  {loading ? (
                    <span className="loading loading-spinner loading-sm" />
                  ) : (
                    'Send Reset Link'
                  )}
                </button>

                <Link to="/login" className="btn btn-ghost btn-sm w-full mt-2">
                  Back to login
                </Link>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
